import { userInformationStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

// Apply comprehensive Surya theme styling with 28px title
userInformationStyles.userInformationTitle = {
    variant: "h4",
    css: css`
        color: ${COLORS.text.main};
        font-family: ${TYPOGRAPHY.fontFamily.base} !important;
        font-weight: ${TYPOGRAPHY.weight.bold} !important;
        font-size: 20px !important;
        line-height: 28px !important;
        font-style: ${TYPOGRAPHY.h4.fontStyle} !important;
    `,
};

userInformationStyles.userInformationGridItem = {
    width: 12,
    css: css`
        label, input, span, div {
            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
        }
        
        label {
            color: ${COLORS.text.main} !important;
            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
            font-weight: ${TYPOGRAPHY.weight.base} !important;
        }
        
        input {
            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
            color: ${COLORS.text.main} !important;
        }
        
        input:disabled {
            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
        }
        
        div[data-test-selector*="error"], 
        span[data-test-selector*="error"],
        .error {
            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
        }
    `,
};

userInformationStyles.changePasswordLink = {
    css: css`
        margin-left: 10px;
        font-family: ${TYPOGRAPHY.fontFamily.base} !important;
        color: ${COLORS.text.link} !important;
        font-weight: ${TYPOGRAPHY.weight.bold} !important;
        
        &:hover {
            text-align: center;
            text-decoration-line: underline;
            color: ${COLORS.text.link} !important;
        }
    `,
};